import { Button, Tooltip } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Page from '../../common/Page'
import PageCard from '../../common/PageCard'
import Actions from '../../../actions'
import $t from '../../../i18n'
import NavigationCard from '../Profile/NavigationCard'
import dayjs from 'dayjs'
import config from '../../../config.json'
import Card from '../../common/Card'
import EmptyList from '../../common/EmptyList'
import { event, eventTypes } from '../../../consts/eventConsts'
import { isMemberTermed } from '../../../utils/hmoUtils'

import './PaymentsAndBilling.css'
import { HMOProviders, routes } from '../../../consts'
import NHPaymentsAndBilling from '../NHPaymentsAndBilling'

const PaymentsAndBilling = () => {
  const dispatch = useDispatch()

  const userDetails = useSelector(state => state.profile.userDetails)
  const links = useSelector(state => state.app.links)
  const {
    paymentDetailsData,
    isPaymentDetailsLoading,
    isPaymentDetailsFailed,
    loadingInvoiceId,
    isLoadingCheckoutPage
  } = useSelector(state => state.payment)

  const userHomeAddressState = useSelector(
    state => state.account?.userHomeAddressState
  )

  const billingBalanceNH = useSelector(state => state.nhMember.billingBalance)

  const future_subscriptions = useSelector(
    state => state.payment.future_subscriptions
  )

  const { invoices, paymentHistory, accountSummary } = paymentDetailsData || {}

  const isAutoPay = accountSummary?.isAutoPay

  const [shouldDisplayHistory, setShouldDisplayHistory] = useState(false)
  const [shouldDisplayInvoices, setShouldDisplayInvoices] = useState(false)
  const [isHNPaymentPage, setIsHNPaymentPage] = useState(false)

  const shouldShowFooterAction = !isMemberTermed(userDetails)

  const billingBalance = accountSummary?.totalBalance
  const overdueBalance = accountSummary?.overdueBalance
  const lastDueDate = dayjs(accountSummary?.dueDate)
    ?.local()
    ?.format('MMM DD, YYYY')
  const hasMultipleSubscriptions = accountSummary?.hasMultipleSubscriptions

  useEffect(() => {
    const isFutureSubscriptionExist = !!future_subscriptions?.[0]
    const isNHProvider =
      userDetails?.hmo_data?.hmo_provider === HMOProviders.NIRVANA

    // if no future subscription and user is NH provider, show the NH payment page on start
    // future subscription if exist will be zoura subscription so we will show new payment and billing with option to move to nh page (if balance exist)
    setIsHNPaymentPage(!isFutureSubscriptionExist && isNHProvider)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails])

  const handleAction = item => {
    if (item?.action) {
      item.action()
    }
  }
  const paymentsCategories = [
    {
      label: $t('pages.paymentsAndBilling.history.title'),
      action: () => {
        analyticsEvent('Payment status')
        setShouldDisplayHistory(true)
      }
    },
    {
      label: $t('pages.paymentsAndBilling.invoices.title'),
      action: () => {
        analyticsEvent('Payment history')
        setShouldDisplayInvoices(true)
      }
    },
    {
      label: $t('pages.paymentsAndBilling.manage.title'),
      action: () => {
        analyticsEvent('Manage payments')
        dispatch(
          Actions.createAction(Actions.NAVIGATED_TO, routes.MANAGE_PAYMENTS)
        )
      }
    }
  ]

  const analyticsEvent = eventName => {
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.click,
        eventName: event.clickEvent.click,
        element: eventName
      })
    )
  }

  const getSubtitle = () => {
    return (
      <div>
        {$t('pages.paymentsAndBilling.subtitleZoura')}{' '}
        <Button type='link' onClick={() => window.open(links?.FAQ || '')}>
          {$t('pages.paymentsAndBilling.readMore')}
        </Button>
      </div>
    )
  }

  const handleBack = () => {
    // if one of the option true, we should back to main (make both false)
    if (shouldDisplayHistory || shouldDisplayInvoices) {
      setShouldDisplayHistory(false)
      setShouldDisplayInvoices(false)
    } else {
      // in case both of the above is false, navigate back from payments page to the previous route
      dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
    }
  }

  const onRequestInvoice = (invoiceFile, invoiceId) => {
    dispatch(
      Actions.createAction(Actions.PAYMENT_INVOICE_REQUESTED, {
        invoiceFile,
        invoiceId
      })
    )
  }

  const renderHome = () => {
    return (
      <>
        {paymentsCategories
          .filter(action => !action.hidden)
          .map((item, index) => (
            <div key={index}>
              <NavigationCard
                key={index}
                label={item?.label}
                className='trackable'
                handleClick={() => handleAction(item)}
              ></NavigationCard>
              <div className='divider'></div>
            </div>
          ))}
        {
          //This is the NH balance card
          // we are showing this card only if the user is NH provider and has a balance
          // if he is no nh, the balance will be 0 or null so this banner won't show
          // this is explicit for 2024/2025 cut off
          // when removing Nirvana we can remove this code!
          billingBalanceNH > 0 && (
            <div className='previous-subscription-indication'>
              <div className='title semi-bold'>
                $
                {$t('pages.paymentsAndBilling.paymentBalance', {
                  balance: billingBalanceNH?.toFixed(2)
                })}
              </div>
              <div className='link' onClick={() => setIsHNPaymentPage(true)}>
                {$t('pages.paymentsAndBilling.goToBalancePage', {
                  year: '2024'
                })}
              </div>
            </div>
          )
        }
      </>
    )
  }

  const renderHistory = () => {
    return (
      <Card className='payment-history-page'>
        <div className='history-header'>
          <div className='history-title semi-bold'>
            {$t('pages.paymentsAndBilling.history.title')}
          </div>
        </div>
        {!paymentHistory?.length && (
          <EmptyList title={$t('pages.paymentsAndBilling.noInfo')} />
        )}
        {!!paymentHistory?.length && (
          <div className='history-table'>
            <div className='history-table-header row'>
              <div className='history-table-column'>
                {' '}
                {$t('pages.paymentsAndBilling.history.date')}
              </div>
              <div className='history-table-column'>
                {' '}
                {$t('pages.paymentsAndBilling.history.amount')}
              </div>
              <div className='history-table-column'>
                {' '}
                {$t('pages.paymentsAndBilling.history.status')}
              </div>
            </div>
            {paymentHistory?.map(item => (
              <div className='history-table-row row' key={item?.id}>
                <div className='history-table-column'>
                  {dayjs(item?.effectiveDate)?.format(config.genericDateFormat)}
                </div>
                <div className='history-table-column'>${item?.amount}</div>
                <div
                  className='history-table-column status semi-bold'
                  data-status={item?.status}
                >
                  <span>
                    {$t('pages.paymentsAndBilling.history.' + item?.status, {
                      defaults: [
                        {
                          message: $t(
                            'pages.paymentsAndBilling.history.Processed'
                          )
                        }
                      ]
                    })}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    )
  }

  const renderInvoices = () => {
    return (
      <Card className='payment-history-page'>
        <div className='history-header'>
          <div className='history-title semi-bold'>
            {$t('pages.paymentsAndBilling.invoices.title')}
          </div>
        </div>
        {!invoices?.length && (
          <EmptyList title={$t('pages.paymentsAndBilling.noInfo')} />
        )}
        {!!invoices?.length && (
          <div className='history-table'>
            {invoices?.map(invoice => (
              <div className='history-table-row row' key={invoice?.id}>
                <div className='history-table-column'>
                  {dayjs(invoice?.invoiceDate)?.format('MMM')}
                </div>
                <div className='history-table-column'>${invoice?.amount}</div>
                <div className='history-table-column'>
                  {dayjs(invoice?.dueDate)?.format(config.genericDateFormat)}
                </div>
                <div className='history-table-column'>
                  <Button
                    type='link'
                    loading={loadingInvoiceId === invoice?.id}
                    onClick={() =>
                      onRequestInvoice(invoice?.invoiceFile, invoice?.id)
                    }
                  >
                    {$t('pages.paymentsAndBilling.invoices.download')}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    )
  }

  if (isHNPaymentPage)
    return (
      <NHPaymentsAndBilling
        onSwitchPaymentPage={() => setIsHNPaymentPage(false)}
      />
    )

  return (
    <PageCard
      enableBack={true}
      onBack={handleBack}
      className='payments-billing-page-card'
    >
      <Page
        title={
          shouldDisplayHistory
            ? $t('pages.paymentsAndBilling.history.title')
            : shouldDisplayInvoices
            ? $t('pages.paymentsAndBilling.invoices.title')
            : $t('pages.paymentsAndBilling.title')
        }
        subtitle={
          shouldDisplayHistory || shouldDisplayInvoices ? null : getSubtitle()
        }
        className='payments-and-billing-page'
        hideAlertBanner
        loading={isPaymentDetailsLoading}
      >
        {isPaymentDetailsFailed && (
          <img
            className='billing-error-img'
            src={config.gcpStorageUrl + '/img/billing-error.png'}
            alt=''
          />
        )}
        {!isPaymentDetailsFailed && (
          <>
            {' '}
            <div className='body-container'>
              {shouldDisplayHistory
                ? renderHistory()
                : shouldDisplayInvoices
                ? renderInvoices()
                : renderHome()}
            </div>
            {shouldShowFooterAction && (
              <div className='page-footer'>
                <div className='payment-balance-card'>
                  {!isAutoPay && (
                    <div className='payment-balance-card-title'>
                      {hasMultipleSubscriptions ? (
                        <span>
                          {$t(
                            'pages.paymentsAndBilling.amountDueMultipleSubscriptions'
                          )}
                        </span>
                      ) : (
                        <span>
                          {$t('pages.paymentsAndBilling.amount', {
                            date: lastDueDate
                          })}
                        </span>
                      )}
                      <div className='payment-balance-card-amount'>
                        ${billingBalance?.toFixed(2)}
                      </div>
                      {!!overdueBalance && (
                        <div className='payment-overdue-amount'>
                          {$t('pages.paymentsAndBilling.overdueAmount', {
                            amount: overdueBalance.toFixed(2)
                          })}
                        </div>
                      )}
                    </div>
                  )}
                  {!isAutoPay && !!billingBalance && (
                    <Button
                      type='primary'
                      className='pay-button'
                      loading={isLoadingCheckoutPage}
                      onClick={() =>
                        dispatch(
                          Actions.createAction(
                            Actions.REDIRECTED_TO_CHECKOUT_PAGE,
                            { selectedPlan: null, customerCoupon: null }
                          )
                        )
                      }
                    >
                      {$t('pages.paymentsAndBilling.countinuePayment')}
                    </Button>
                  )}
                  {!isAutoPay && !billingBalance && (
                    <Button
                      type='primary'
                      className='auto-pay-button'
                      onClick={() =>
                        dispatch(
                          Actions.createAction(
                            Actions.NAVIGATED_TO,
                            routes.MANAGE_PAYMENTS
                          )
                        )
                      }
                    >
                      {$t('pages.paymentsAndBilling.autoPay')}
                    </Button>
                  )}
                  {!isAutoPay && (
                    <div className='check-option'>
                      {$t('pages.paymentsAndBilling.checkOption')}?
                      <Tooltip
                        title={$t(
                          'pages.paymentsAndBilling.checkOptionTooltip',
                          { state: userHomeAddressState }
                        )}
                        placement='bottom'
                        color={'var(--white)'}
                        textColor={'var(--textColor)'}
                        overlayClassName='check-tooltip'
                      >
                        <i className='icon-info'></i>
                      </Tooltip>
                    </div>
                  )}
                  {isAutoPay && (
                    <div className='row auto-pay-desc-wrapper'>
                      <i className='icon-check' />
                      <div className='auto-pay-desc'>
                        {' '}
                        {hasMultipleSubscriptions
                          ? $t(
                              'pages.paymentsAndBilling.autoPayDesctiptionNoBalance'
                            )
                          : !!billingBalance
                          ? $t('pages.paymentsAndBilling.autoPayDesctiption', {
                              amount: billingBalance?.toFixed(2)
                            })
                          : $t(
                              'pages.paymentsAndBilling.autoPayDesctiptionNoBalance'
                            )}
                      </div>
                    </div>
                  )}
                </div>
                {!isAutoPay && !!billingBalance && (
                  <div className='payment-note'>
                    {$t('pages.paymentsAndBilling.paymentNote')}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </Page>
    </PageCard>
  )
}
export default PaymentsAndBilling
